export function uploadAndEditBookDTO(payload) {
  const result = {
    author: payload.author || '',
    description: payload.description || '',
    fileSize: payload.pdfInfo?.size || '0.1',
    isbn: payload.isbn || '',
    major: payload.major || 'Đại cương',
    pages: isNaN(parseInt(payload.pdfInfo?.pages))
      ? 1
      : payload.pdfInfo?.pages.toString(),
    price: payload.price?.toString() || '0',
    publishYear:
      payload.publishYear?.toString() || new Date().getFullYear().toString(),
    publisher: payload.publisher || 'NXB Đại học Kinh tế Quốc dân',
    subject: payload.subject || '',
    title: payload.title || '',
    readieEnabled: payload.pdfInfo?.readieEnabled?.toString() || 'true',
    status: payload.status || 'ACTIVE',
    facultyUuid: payload.facultyUuid || '87792a91-ca6d-4f14-8399-7216eec15b80',
    categoryUuid:
      payload.categoryUuid || 'd9e1764a-91b1-40d0-93a8-66d2b0fafff6',
    bookCollections: payload.bookCollections || [],
  }
  return result
}
